import { Country } from '@csp/csp-common-model';
import { OrgType, createOrgV1Mock } from '@csp/dmdp-api-org-dto';
import { createMockCreator } from '@csp/test-common-utils';
import { CountryMapper } from '../../mapper/CountryMapper';

export const createCountryMock = createMockCreator<Country>({
  ...CountryMapper.fromOrgV1(
    createOrgV1Mock({
      type: OrgType.COUNTRY,
      name: 'Sweden',
      country: {
        countryCode: 'SE',
        langCodes: ['sv'],
      },
      branchParentIds: ['tree_1'],
      practice: undefined,
    }),
  ),
});
